import styles from "./LSingleColumn.module.css";

/**
 * LSingleColumn — page layout z jedną kolumną `main` plus opcjonalny hero
 * na całą szerokość nad nią.
 *
 * Słot `main` przyjmuje React.ReactNode (zwykle `<WindowArea name="main" />`
 * dla homepage; w Fazie F.1+ catalog page wstawi `<CatalogContentArea />`).
 *
 * **Strefa hero** (`heroLarge`) jest opcjonalna - gdy prop nie podany, sekcja
 * nie jest renderowana w ogóle. Gdy podany, ale pusty (brak okien w strefie),
 * CSS `:has(article)` gate ukrywa kontener hero.
 *
 * Klucz strefy zostaje `heroLarge` (zapisany w `imp_cms_catalog_window.area`),
 * choć boczne strefy `heroSmallTop` / `heroSmallBottom` zostały usunięte
 * 2026-09-23 - karty realizacji rysuje teraz sam akapit hero (układ 85).
 *
 * Convention: page layouts (folder `pages/`) NIE mają dedykowanego catalog
 * area — są dla homepage / static pages. Catalog layouts (folder `catalogs/`,
 * Faza F.1) dziedziczą strukturę ale `main` slot to catalog content.
 */
export function LSingleColumn({ main, heroLarge }: LSingleColumnProps) {
  return (
    <div className={styles.root}>
      {heroLarge !== undefined && (
        <div className={styles.hero}>
          <div className={styles.heroLarge}>{heroLarge}</div>
        </div>
      )}
      <div className={styles.main}>{main}</div>
    </div>
  );
}

export type LSingleColumnProps = {
  main: React.ReactNode;
  heroLarge?: React.ReactNode;
};
